import { ModerationType } from '../const/ModerationTypes'

const DEFINE_PROJECT_ORDER_ALLOWED_MODERATION_TYPES = [2, 4, 5, 6] as const

export const DEFINE_PROJECT_ORDER_CONTENT_TYPES = ['main', 'projects', 'organizations'] as const

export type DefineProjectOrderScopeOptions = {
  forTab?: boolean
}

const isDefineProjectOrderContentTypeAllowed = (entityType?: string): boolean => (
  DEFINE_PROJECT_ORDER_CONTENT_TYPES.some((type) => type === entityType)
)

const isOrganizationsEntityType = (entityType?: string): boolean => (
  entityType === 'organizations'
)

export const getModerationTypeValue = (
  moderationType: unknown,
  teamModerationType?: unknown,
): number | undefined => {
  let value: unknown

  if (typeof moderationType === 'number') {
    value = moderationType
  } else if (moderationType && typeof moderationType === 'object' && 'value' in moderationType) {
    value = (moderationType as { value?: unknown }).value
  } else if (typeof teamModerationType === 'number') {
    value = teamModerationType
  }

  if (typeof value === 'number' && !Number.isNaN(value)) {
    return value
  }

  if (typeof value === 'string' && value !== '') {
    const parsed = Number(value)
    return Number.isNaN(parsed) ? undefined : parsed
  }

  return undefined
}

export const isDefineProjectOrderModerationTypeAllowed = (
  moderationType: unknown,
  teamModerationType?: unknown,
): boolean => {
  const moderationTypeValue = getModerationTypeValue(moderationType, teamModerationType)
  if (typeof moderationTypeValue !== 'number') return false

  return DEFINE_PROJECT_ORDER_ALLOWED_MODERATION_TYPES.some((type) => type === moderationTypeValue)
}

export const isOuterModerationType = (
  moderationType: unknown,
  teamModerationType?: unknown,
): boolean => (
  getModerationTypeValue(moderationType, teamModerationType) === ModerationType.Outer
)

export const isDefineProjectOrderScopeAllowed = (
  moderationType: unknown,
  entityType?: string,
  teamModerationType?: unknown,
  options?: DefineProjectOrderScopeOptions,
): boolean => {
  if (isOrganizationsEntityType(entityType)) {
    return true
  }

  if (isOuterModerationType(moderationType, teamModerationType)) {
    if (options?.forTab) {
      return true
    }

    return !isOrganizationsEntityType(entityType)
  }

  return isDefineProjectOrderModerationTypeAllowed(moderationType, teamModerationType)
}

export const canShowDefineProjectOrder = (
  moderationType: unknown,
  entityType?: string,
  teamModerationType?: unknown,
  options?: DefineProjectOrderScopeOptions,
): boolean => {
  if (isOuterModerationType(moderationType, teamModerationType)) {
    if (options?.forTab) {
      return true
    }

    return !isOrganizationsEntityType(entityType)
  }

  if (!isDefineProjectOrderContentTypeAllowed(entityType)) {
    return false
  }

  return isDefineProjectOrderScopeAllowed(moderationType, entityType, teamModerationType)
}
import { ModerationType } from '../const/ModerationTypes'

const DEFINE_PROJECT_ORDER_ALLOWED_MODERATION_TYPES = [2, 4, 5, 6] as const

export const DEFINE_PROJECT_ORDER_CONTENT_TYPES = ['main', 'projects', 'organizations'] as const

export type DefineProjectOrderScopeOptions = {
  forTab?: boolean
}

const isDefineProjectOrderContentTypeAllowed = (entityType?: string): boolean => (
  DEFINE_PROJECT_ORDER_CONTENT_TYPES.some((type) => type === entityType)
)

const isOrganizationsEntityType = (entityType?: string): boolean => (
  entityType === 'organizations'
)

export const getModerationTypeValue = (
  moderationType: unknown,
  teamModerationType?: unknown,
): number | undefined => {
  let value: unknown

  if (typeof moderationType === 'number') {
    value = moderationType
  } else if (moderationType && typeof moderationType === 'object' && 'value' in moderationType) {
    value = (moderationType as { value?: unknown }).value
  } else if (typeof teamModerationType === 'number') {
    value = teamModerationType
  }

  if (typeof value === 'number' && !Number.isNaN(value)) {
    return value
  }

  if (typeof value === 'string' && value !== '') {
    const parsed = Number(value)
    return Number.isNaN(parsed) ? undefined : parsed
  }

  return undefined
}

export const isDefineProjectOrderModerationTypeAllowed = (
  moderationType: unknown,
  teamModerationType?: unknown,
): boolean => {
  const moderationTypeValue = getModerationTypeValue(moderationType, teamModerationType)
  if (typeof moderationTypeValue !== 'number') return false

  return DEFINE_PROJECT_ORDER_ALLOWED_MODERATION_TYPES.some((type) => type === moderationTypeValue)
}

export const isOuterModerationType = (
  moderationType: unknown,
  teamModerationType?: unknown,
): boolean => (
  getModerationTypeValue(moderationType, teamModerationType) === ModerationType.Outer
)

export const isDefineProjectOrderScopeAllowed = (
  moderationType: unknown,
  entityType?: string,
  teamModerationType?: unknown,
  options?: DefineProjectOrderScopeOptions,
): boolean => {
  if (isOrganizationsEntityType(entityType)) {
    return true
  }

  if (isOuterModerationType(moderationType, teamModerationType)) {
    if (options?.forTab) {
      return true
    }

    return !isOrganizationsEntityType(entityType)
  }

  return isDefineProjectOrderModerationTypeAllowed(moderationType, teamModerationType)
}

export const canShowDefineProjectOrder = (
  moderationType: unknown,
  entityType?: string,
  teamModerationType?: unknown,
  options?: DefineProjectOrderScopeOptions,
): boolean => {
  if (isOuterModerationType(moderationType, teamModerationType)) {
    if (options?.forTab) {
      return true
    }

    return !isOrganizationsEntityType(entityType)
  }

  if (!isDefineProjectOrderContentTypeAllowed(entityType)) {
    return false
  }

  return isDefineProjectOrderScopeAllowed(moderationType, entityType, teamModerationType)
}
